import LocationsPage from 'src/dispensary/core-menu/locations';

export default LocationsPage;
